/* tslint:disable */
/* eslint-disable */
/* Mocked in-memory implementation of TransfersClient for local development and UI wiring. */

import { CancelToken } from 'axios';
import {
  SuccessResponse_1OfGetTransfersResponse,
  SuccessResponse_1OfTransferHeader,
  ValidateItemQuantityRequest,
  ValidateItemQuantityResponse,
  CreateTransferRequest,
  ReceiveTransferHeaderRequest,
} from '../../types';

/* ---- Helper Functions ---- */

function delay(ms: number = 300): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

function successResponse<T>(data: T): { data: T; success: boolean; message: string } {
  return { data, success: true, message: 'Success' };
}

/* ---- Mock Data ---- */

const mockTransfers = [
  {
    id: 1,
    transferNumber: 'TRF-001',
    fromStore: 'STORE001',
    toStore: 'STORE002',
    status: 'Pending',
    transferDate: '2025-12-12',
    itemCount: 5,
    transferType: 'Outbound',
  },
  {
    id: 2,
    transferNumber: 'TRF-002',
    fromStore: 'STORE003',
    toStore: 'STORE001',
    status: 'Received',
    transferDate: '2025-12-10',
    itemCount: 8,
    transferType: 'Inbound',
  },
];

/* ---- Mocked Client Implementation ---- */

import { ITransfersClient } from '../../interfaces';
export class TransfersClientMocked implements ITransfersClient {
  constructor(baseUrl?: string) {}

  async validateitemquantity(body?: ValidateItemQuantityRequest, cancelToken?: CancelToken): Promise<ValidateItemQuantityResponse> {
    await delay();
    return {
      isValid: true,
      availableQuantity: 50,
      requestedQuantity: body?.quantity || 0,
      message: 'Quantity available',
    } as ValidateItemQuantityResponse;
  }

  async transfersGET(
    storeNumber?: string,
    transferNumber?: number,
    transferType?: string,
    date?: string,
    fieldToSort?: string,
    sortDirection?: string,
    skip?: number,
    take?: number,
    archived?: boolean,
    cancelToken?: CancelToken
  ): Promise<SuccessResponse_1OfGetTransfersResponse> {
    await delay();
    let filtered = [...mockTransfers];

    if (storeNumber) {
      filtered = filtered.filter((t) => t.fromStore === storeNumber || t.toStore === storeNumber);
    }
    if (transferNumber) {
      filtered = filtered.filter((t) => t.transferNumber.includes(transferNumber.toString()));
    }
    if (transferType) {
      filtered = filtered.filter((t) => t.transferType === transferType);
    }

    const start = skip || 0;
    const end = start + (take || 10);

    return successResponse({
      transfers: filtered.slice(start, end),
      totalCount: filtered.length,
    }) as SuccessResponse_1OfGetTransfersResponse;
  }

  async transfersPOST(body?: CreateTransferRequest, cancelToken?: CancelToken): Promise<void> {
    await delay();
    if (body) {
      mockTransfers.push({
        id: mockTransfers.length + 1,
        transferNumber: `TRF-00${mockTransfers.length + 1}`,
        fromStore: body.storeNumber || '',
        toStore: body.otherStoreNumber || '',
        status: 'Pending',
        transferDate: body.transferDate || new Date().toISOString().split('T')[0],
        itemCount: body.items?.length || 0,
        transferType: body.transferType || 'Outbound',
      });
    }
  }

  async transfersGET2(id: number, userStore?: string, cancelToken?: CancelToken): Promise<SuccessResponse_1OfTransferHeader> {
    await delay();
    const transfer = mockTransfers.find((t) => t.id === id) || mockTransfers[0];
    return successResponse({
      ...transfer,
      items: [
        { itemNumber: 'ITEM001', description: 'Whole Milk', quantity: 12 },
        { itemNumber: 'ITEM002', description: 'White Bread', quantity: 10 },
      ],
    }) as SuccessResponse_1OfTransferHeader;
  }

  async transfersPATCH(id: number, body?: ReceiveTransferHeaderRequest, cancelToken?: CancelToken): Promise<void> {
    await delay();
    const transfer = mockTransfers.find((t) => t.id === id);
    if (transfer) {
      transfer.status = 'Received';
    }
  }

  async transfersDELETE(id: number, cancelToken?: CancelToken): Promise<void> {
    await delay();
    const index = mockTransfers.findIndex((t) => t.id === id);
    if (index > -1) {
      mockTransfers.splice(index, 1);
    }
  }

  // ====== Auto-generated stub methods ======









}
